import { ReactNode } from "react";
import { translate } from "utils";
import { Button } from "antd";
import { PlusOutlined, SaveOutlined } from "@ant-design/icons";
import clsx from "clsx";

export function CreateBtn({
	onClick,
	htmlType = "submit",
	icon = "plus",
	children,
	className,
	circle,
	disabled
}: {
	onClick?: () => void;
	htmlType?: "button" | "submit";
	icon?: "plus" | "save";
	children?: ReactNode;
	className?: string;
	circle?: boolean;
	disabled?: boolean
}) {
	return (
		<Button
			shape={circle ? "circle" : "default"}
			icon={icon === "plus" ? <PlusOutlined /> : <SaveOutlined />}
			type="primary"
			htmlType={htmlType}
			className={clsx(
				"bg-green-500 hover:bg-green-700 focus:bg-green-500 flex items-center justify-center border-0",
				className,
				!circle ? "rounded" : ""
			)}
			onClick={() => {
				!!onClick && onClick();
			}}
			disabled={disabled}
		>
			{!circle && (children || translate(`Create`))}
		</Button>
	);
}
